import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import { Quote } from 'lucide-react';

export function PrincipalMessage({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const principalName = data.principal_name || null;
  const principalTitle = data.principal_title || null;
  const principalMessage = data.principal_message || null;
  const principalImage = data.principal_image || null;

  if (!principalName && !principalMessage) return null;

  return (
    <Box id="principal-message" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#ffffff' }}>
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 5,
            backgroundColor: `${primaryColor}05`,
            border: `1px solid ${primaryColor}15`,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Grid container spacing={5} sx={{ alignItems: 'center' }}>
            {/* Principal Photo if present */}
            {principalImage && (
              <Grid size={{ xs: 12, md: 4 }}>
                <Box sx={{ position: 'relative', textAlign: 'center' }}>
                  <Box
                    component="img"
                    src={principalImage}
                    alt={principalName || 'Principal'}
                    sx={{
                      width: { xs: 220, md: 260 },
                      height: { xs: 220, md: 260 },
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: `6px solid #ffffff`,
                      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.12)',
                    }}
                  />
                </Box>
              </Grid>
            )}

            {/* Principal Message Content */}
            <Grid size={{ xs: 12, md: principalImage ? 8 : 12 }}>
              <Box sx={{ position: 'relative' }}>
                <Quote
                  size={80}
                  style={{
                    position: 'absolute',
                    top: 30,
                    left: -20,
                    opacity: 0.08,
                    color: primaryColor,
                    zIndex: 0,
                  }}
                />
                <Box sx={{ position: 'relative', zIndex: 1, display: 'inline-block', px: 2.5, py: 0.75, borderRadius: 4, backgroundColor: primaryColor, mb: 2, boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                  <Typography variant="caption" fontWeight={800} letterSpacing="0.08em" sx={{ color: '#ffffff', textTransform: 'uppercase' }}>
                    LEADERSHIP DESK
                  </Typography>
                </Box>
                <Typography variant="h3" fontWeight={800} color="#0f172a" sx={{ mb: 2, fontSize: { xs: '1.75rem', md: '2.25rem' } }}>
                  Message from the Principal
                </Typography>
                {principalMessage && (
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#334155',
                      fontSize: { xs: '1rem', md: '1.125rem' },
                      lineHeight: 1.8,
                      fontStyle: 'italic',
                      mb: 3,
                    }}
                  >
                    "{principalMessage}"
                  </Typography>
                )}

                {(principalName || principalTitle) && (
                  <Box>
                    {principalName && (
                      <Typography variant="h6" fontWeight={800} color={primaryColor}>
                        {principalName}
                      </Typography>
                    )}
                    {principalTitle && (
                      <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                        {principalTitle}
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
}

export default PrincipalMessage;
